import { Linkedin, Instagram } from "lucide-react";
import { landingContent } from "@/content/landing";

interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  const { footer } = landingContent;

  return (
    <footer className={className ?? "bg-primary text-primary-foreground py-12"}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Tagline */}
        <p className="text-center text-sm text-primary-foreground/60 max-w-3xl mx-auto mb-10">
          {footer.tagline}
        </p>

        {/* Main Footer Content */}
        <div className="flex flex-col lg:flex-row justify-between gap-8">
          {/* Logo & Social */}
          <div className="flex flex-col items-center lg:items-start gap-4">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent">
                <span className="text-xl font-bold text-white">R</span>
              </div>
              <span className="text-lg font-bold text-white">Recovery Jobs</span>
            </div>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/recovery-jobs.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-white/80 transition-colors"
              >
                <Linkedin className="w-6 h-6" />
              </a>
              <a
                href="https://www.instagram.com/recoveryjobs/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-white/80 transition-colors"
              >
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Nav Columns */}
          {footer.navColumns.map((column, index) => (
            <div
              key={index}
              className="flex flex-col items-center lg:items-start gap-3"
            >
              {column.links.map((link) => (
                <a
                  key={link.text}
                  href={link.href}
                  className="text-sm text-white hover:text-white/80 transition-colors"
                >
                  {link.text}
                </a>
              ))}
            </div>
          ))}

          {/* Contact */}
          <div className="flex flex-col items-center lg:items-end gap-3 text-right">
            <span className="text-sm text-white">{footer.website}</span>
            <a
              href={`mailto:${footer.email}`}
              className="text-sm text-white hover:text-white/80 transition-colors"
            >
              {footer.email}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
